<template>
  <div class="setting-panel">
    <div class="setting-panel-wrapper" :class="{ 'close-setting-panel': !settingPanelShow }">
      <div class="setting-design-panel" :style="{ height: settingPanelShow ? '54.5px' : '48px' }">
        <div class="change-chart-type-menu" v-show="selectItem._id && settingPanelShow"
          @click="toggleChartTypeDropdown">
          <div class="components-item">
            <div :class="selectItem.className"></div>
          </div>
          <span>{{ widgetConfig[selectItem.type] && widgetConfig[selectItem.type].name }}</span>
          <i class="el-icon-caret-bottom" :class="{ 'is-expanded': isChartTypeDropdownOpen }"></i>
        </div>
        <!-- 图表类型下拉容器 -->
        <div class="chart-type-dropdown-overlay" v-if="isChartTypeDropdownOpen" @click="closeChartTypeDropdown">
          <div class="chart-type-dropdown-container" @click.stop>
            <div class="chart-type-widgets">
              <div v-for="chartType in availableChartTypes" :key="chartType.type" class="chart-type-item"
                @click="changeChartType(chartType)">
                <div class="chart-type-icon">
                  <div :class="chartType.className"></div>
                </div>
                <span class="chart-type-name">{{ chartType.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <i class="el-icon-s-unfold self-icon" @click="tabPanelCloseOrOpen"></i>
      </div>
      <template v-if="settingPanelShow">
        <c-tabs :tabList="tabList" v-model="activeTab" @change="handleTabChange" />
        <div class="ui-schema-antd-tabs-content">
          <!-- 字段标签页 -->
          <field-tab :getDwsData="getDwsData" @on-update-single-chart="handleUpdateSingleChart" ref="fieldTabRef" :custom_updateData="custom_updateData" v-if="activeTab === TAB_TYPES.FIELD" :fields="selectItem.fields || []" :selectItem="selectItem"
            @updateDashboard="updateDashboard" @updateFetchData="updateFetchData" />
          <!-- 样式标签页 -->
          <style-tab v-else-if="activeTab === TAB_TYPES.STYLE" :select-item="selectItem"
            @styleUpdate="handleStyleUpdate" />
          <!-- 高级标签页 -->
          <div v-else-if="activeTab === TAB_TYPES.ADVANCED" class="tab-content">
            <p>高级配置内容</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="jzliu-bi-engine-setting-panel-vertical-text">
          <div class="jzliu-bi-engine-vertical-text" @click="handleHideTabChange(TAB_TYPES.FIELD)">字段</div>
          <div class="jzliu-bi-engine-vertical-text" @click="handleHideTabChange(TAB_TYPES.STYLE)">样式</div>
        </div>
      </template>
    </div>
    <data-panel @preview-detail="previewDetail" :globalConfig="globalConfig" :selectItem="selectItem"></data-panel>
  </div>
</template>

<script>
import dataPanel from './dataPanel'
import fieldTab from './settingPanel/fieldTab'
import styleTab from './settingPanel/styleTab'
import cTabs from './base/cTabs'
// import { mapMutations } from 'vuex'
import { TAB_TYPES } from '../utils/enum.data'
import { panelMap } from '../utils/panelConf'
import { widgetConfig } from '../utils/enum.data'
import { set } from 'lodash'
import { updateChartDataHelper } from '../utils/index'
import { widgetTypeMap } from '../utils/enum.data'

export default {
  name: 'settingPanel',
  components: { dataPanel, fieldTab, styleTab, cTabs },
  props: {
    getDwsData: {
      type: Function,
      default: () => Promise.resolve([])
    },
    hideGauge: {
      type: Boolean,
      default: false
    },
    selectItem: {
      type: Object,
      default: () => ({})
    },
    custom_updateData: {
      type: Function | Object,
      default: null,
    },
    globalConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      settingPanelShow: true,
      isPut: true,
      // 字段
      fields: [],
      // 当前激活的标签页
      activeTab: TAB_TYPES.FIELD,
      // 标签页类型枚举
      TAB_TYPES,
      // 图表类型下拉相关
      isChartTypeDropdownOpen: false,
      widgetConfig,
    }
  },
  computed: {
    // 标签页列表
    tabList() {
      return [
        { key: TAB_TYPES.FIELD, label: '字段' },
        { key: TAB_TYPES.STYLE, label: '样式' },
        // { key: TAB_TYPES.ADVANCED, label: '高级' }
      ]
    },
    // 可用的图表类型列表
    availableChartTypes() {
      return this.hideGauge ? Object.values(panelMap).filter(chartType => chartType.type !== widgetTypeMap.Gauge) : Object.values(panelMap)
    }
  },
  // 移除 created 中的 $bus 监听，因为现在通过 props 传递
  mounted() {
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleGlobalClick)
    // 添加窗口大小改变监听器
    window.addEventListener('resize', this.positionDropdown)
  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleGlobalClick)
    // 移除窗口大小改变监听器
    window.removeEventListener('resize', this.positionDropdown)
  },
  methods: {
    previewDetail(selectItem) {
      this.$emit('preview-detail', selectItem)
    },
    // ...mapMutations(['setDashboardDesignerWidth']),
    tabPanelCloseOrOpen() {
      this.settingPanelShow = !this.settingPanelShow
      this.globalConfig.dashboardDesignerWidth = this.globalConfig.dashboardDesignerWidth + (!this.settingPanelShow ? -200 : 200)
    },
    // 处理标签页切换
    handleTabChange(tabKey) {
      if (Object.values(TAB_TYPES).includes(tabKey)) {
        this.activeTab = tabKey
      }
    },
    handleHideTabChange(tabKey) {
      this.tabPanelCloseOrOpen()
      this.handleTabChange(tabKey)
    },
    handleUpdateSingleChart() {
      this.$emit('on-update-single-chart', this.selectItem)
    },
    // 更新仪表板
    updateDashboard(selectItem) {
      this.$emit('updateDashboard', selectItem)
    },
    updateFetchData(selectItem) {
      this.$emit('updateFetchData', selectItem)
    },
    // 处理样式更新
    handleStyleUpdate(styleConfig) {
      this.$emit('styleUpdate', styleConfig)
    },
    // 图表类型下拉相关方法
    toggleChartTypeDropdown() {
      this.isChartTypeDropdownOpen = !this.isChartTypeDropdownOpen
      if (this.isChartTypeDropdownOpen) {
        this.$nextTick(() => {
          this.positionDropdown()
        })
      }
    },
    positionDropdown() {
      // 获取菜单元素的位置
      const menuElement = this.$el.querySelector('.change-chart-type-menu')
      if (menuElement) {
        const rect = menuElement.getBoundingClientRect()
        const dropdownContainer = this.$el.querySelector('.chart-type-dropdown-container')
        if (dropdownContainer) {
          dropdownContainer.style.top = `${rect.bottom}px`
          dropdownContainer.style.left = `${rect.left}px`
          dropdownContainer.style.width = `${rect.width}px`
        }
      }
    },
    closeChartTypeDropdown() {
      this.isChartTypeDropdownOpen = false
    },
    // 切换图表的时候，清空下钻
    updateChartConfig(updatedItem) {
      const drillFields = updatedItem.fields.find(f => f.alias === 'drill') || {}
      this.$set(drillFields, 'drillFieldsBreadcrumb', [])
      this.$set(updatedItem, 'drillFields', [])
    },
    changeChartType(chartType) {
      const standardItem = chartType
      console.log(chartType, 'standardItem')
      const newChartDimMap = {}
      standardItem.fields.forEach(item => {
        newChartDimMap[item.queryType] = item.limitNum ?? 9999
      })
      // 更新当前选中图表的类型
      if (this.selectItem._id) {
        this.selectItem.fields.forEach(item => {
          item.chooseFields = item.chooseFields.slice(0, newChartDimMap[item.queryType])
          console.log(newChartDimMap[item.queryType],item.chooseFields)
        })
        // 保留原有的数据和配置，只更新图表类型相关属性
        const exCludesKeys = ['legendConfig','lineChartConfig','showRemark','backgroundColor','remark','remarkPosition','showTitle']
        // 排除指定键的辅助函数
        const excludeKeys = (obj, keysToExclude) => {
          const cloned = JSON.parse(JSON.stringify(obj))
          keysToExclude.forEach(key => {
            delete cloned[key]
          })
          return cloned
        }
        const updatedItem = {
          ...this.selectItem,
          type: standardItem.type,
          className: standardItem.className,
          fields: standardItem.fields,
          styleComp: standardItem.styleComp,
          queryList: standardItem.queryList ?? {pageNum: 1, pageSize: 10, total: 0}
        }
        updatedItem.styleConfig.commongConfig = {...updatedItem.styleConfig.commongConfig,...excludeKeys(standardItem.styleConfig.commongConfig, exCludesKeys)}
        updatedItem.styleConfig.helperData = {
          ...updatedItem.styleConfig.helperData,
          fieldMap: {},
          fieldMapClone: {},
          fieldMapCurrent: {},
        }
        this.updateChartConfig(updatedItem)
        // 保留字段选择状态
        const selectItemFieldSelectMap = {}
        const isLineOrBar = [widgetTypeMap.Column, widgetTypeMap.Line].includes(this.selectItem.type) && [widgetTypeMap.Bar, widgetTypeMap.Line].includes(standardItem.type)
        this.selectItem.fields.forEach(item => {
          if (!selectItemFieldSelectMap[item.alias]?.length) {
            selectItemFieldSelectMap[item.alias] = item.chooseFields
          } else if (isLineOrBar && item.queryType === 'columns') {
            selectItemFieldSelectMap[item.queryType] = item.chooseFields
          }
        })
        const tempAliasHanlderMark = {}
        standardItem.fields.forEach(item => {
          if (!tempAliasHanlderMark[item.alias]) {
            item.chooseFields = selectItemFieldSelectMap[item.alias] ?? []
            tempAliasHanlderMark[item.alias] = true
          } else if (isLineOrBar && item.queryType === 'columns') {
            item.chooseFields = selectItemFieldSelectMap[item.queryType] ?? []
            tempAliasHanlderMark[item.queryType] = true
          }
        })
        standardItem.fields = standardItem.fields.filter(f => !!f)
        updatedItem.fields = updatedItem.fields.filter(f => !!f)
        console.log('standardItem:', JSON.parse(JSON.stringify(standardItem)))
        updatedItem.fields = standardItem.fields
        updatedItem.styleConfig.commongConfig.labelConfig.position = ''
        this.$nextTick(() => {
          updateChartDataHelper(updatedItem, this, this.custom_updateData)
        })
        console.log('updatedItem:', JSON.parse(JSON.stringify(updatedItem)))
        // 触发图表类型变更事件
        this.$emit('updateDashboard', updatedItem)

        // 关闭下拉菜单
        this.closeChartTypeDropdown()
        
        this.$message.success(`图表类型已切换为：${chartType.name}`)
      }
    },
    handleGlobalClick(event) {
      // 检查点击是否在组件内部
      if (!this.$el.contains(event.target)) {
        this.closeChartTypeDropdown()
      }
    },
  },
}
</script>

<!-- 样式保持不变 -->
<style scoped lang="less">
// 图表类型下拉样式
.chart-type-dropdown-overlay {
  position: fixed;
  top: 0;
  width: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.3);

  .chart-type-dropdown-container {
    position: absolute;
    top: 0;
    left: 0;
    background: var(--bi-jz-bg-color);
    border: 1px solid var(--bi-jz-border-color);
    border-radius: 0 0 4px 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 10000;
    min-width: 200px;
    max-height: 300px;
    overflow-y: auto;
    animation: slideDown 0.3s ease;

    .chart-type-widgets {
      padding: 12px;

      .chart-type-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        margin-bottom: 4px;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.2s ease;
        height: 48px;

        &:hover {
          background: rgba(255, 255, 255, 0.1);
          border-color: #2e74ff;
        }

        &:last-child {
          margin-bottom: 0;
        }

        .chart-type-icon {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        
          div {
            width: 70px;
            height: 70px;
            display: block;
            position: relative;
            left: 0;
            top: 0;
            background-image: url('../assets/img/panel.png');
            background-repeat: no-repeat;
            -webkit-transform: scale(.5);
            transform: scale(.5);
            transform-origin: left top;
            cursor: pointer;

            // 交叉表图标
            &.component-type-cross-table {
              background-position: 15px -888px;
            }

            // 柱图图标
            &.component-type-bar {
              background-position: -143px -888px;
            }

            // 饼图图标
            &.component-type-pie {
              background-position: -543px -888px;
            }

            // 折线图图标
            &.component-type-line {
              background-position: -306px -888px;
            }

            // 指标卡图标
            &.component-type-indicator-card {
              background-position: -63px -888px;
            }
          }
        }

        .chart-type-name {
          color: var(--bi-jz-font-color);
          font-size: 14px;
          flex: 1;
          line-height: 24px;
          margin-left: 8px;
        }
      }
    }
  }
}

// 图表类型菜单样式
.change-chart-type-menu {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  .el-icon-caret-bottom {
    transition: transform 0.3s ease;

    &.is-expanded {
      transform: rotate(180deg);
    }
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@base-color: var(--bi-jz-font-color);
.base-color {
  color: @base-color;
}

// 标签页激活指示器动画
@keyframes tabActiveIndicator {
  0% {
    width: 0;
    opacity: 0;
  }
  100% {
    width: 30px;
    opacity: 1;
  }
}

.setting-panel {
  height: 100%;
  background: var(--bi-jz-bg-color);
  position: relative;
  display: flex;
  //width: 420px;
  .setting-panel-wrapper {
    width: 240px;
    display: flex;
    flex-direction: column;

    .setting-design-panel {
      height: 54.5px;
      line-height: 54.5px;
      background: var(--bi-jz-bg-color);
      color: var(--bi-jz-font-color);
      font-size: 14px;
      padding: 0 12px;
      border-bottom: 1px solid var(--bi-jz-border-color);
      position: relative;

      .change-chart-type-menu {
        .base-color;
        display: flex;
        align-items: center;
        padding-left: 12px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
    }


    .ui-schema-antd-tabs-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: auto;

      .tab-content {
        padding: 20px;
        color: var(--bi-jz-font-color);
      }
    }
  }
}
.jzliu-bi-engine-setting-panel-vertical-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
